import { render, staticRenderFns } from "./collapsed_state.vue?vue&type=template&id=36d8fd50&"
import script from "./collapsed_state.vue?vue&type=script&lang=js&"
export * from "./collapsed_state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collapsed_state.vue"
export default component.exports